var map = {
	"./033-bm.webp": 1266,
	"./033-cn.webp": 1267,
	"./033.webp": 1268,
	"./13-bm.webp": 1269,
	"./13-cn.webp": 1270,
	"./13.webp": 1271,
	"./3-bm.webp": 1272,
	"./3-cn.webp": 1273,
	"./3.webp": 1274,
	"./angpao-bg-mobile.webp": 1275,
	"./angpao-bg.webp": 1276,
	"./angpao-bm.webp": 1277,
	"./angpao-cn.webp": 1278,
	"./angpao.webp": 1279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1265;